import { z } from 'zod';

const passwordSchema = z.string().min(8, 'La contraseña debe tener al menos 8 caracteres');

export const signInSchema = z.object({
  username: z.string().trim().min(1, 'Ingresá tu usuario'),
  password: z.string().min(1, 'Ingresá tu contraseña'),
  rememberMe: z.boolean(),
});

export const newPasswordRequiredSchema = z
  .object({
    newPassword: passwordSchema,
    confirmPassword: z.string(),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: 'Las contraseñas no coinciden',
    path: ['confirmPassword'],
  });

export const smsConfirmationSchema = z.object({
  code: z
    .string()
    .trim()
    .regex(/^\d{6}$/, 'El código debe tener 6 dígitos'),
});

export const forgotPasswordRequestSchema = z.object({
  username: z.string().trim().min(1, 'Ingresá tu usuario'),
});

export const forgotPasswordConfirmSchema = z
  .object({
    code: z
      .string()
      .trim()
      .regex(/^\d{6}$/, 'El código debe tener 6 dígitos'),
    newPassword: passwordSchema,
    confirmPassword: z.string(),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: 'Las contraseñas no coinciden',
    path: ['confirmPassword'],
  });

export const changePasswordSchema = z
  .object({
    oldPassword: z.string().min(1, 'Ingresá tu contraseña actual'),
    newPassword: passwordSchema,
    confirmPassword: z.string(),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: 'Las contraseñas no coinciden',
    path: ['confirmPassword'],
  });

export type SignInFormValues = z.infer<typeof signInSchema>;
export type NewPasswordRequiredFormValues = z.infer<typeof newPasswordRequiredSchema>;
export type SmsConfirmationFormValues = z.infer<typeof smsConfirmationSchema>;
export type ForgotPasswordRequestFormValues = z.infer<typeof forgotPasswordRequestSchema>;
export type ForgotPasswordConfirmFormValues = z.infer<typeof forgotPasswordConfirmSchema>;
export type ChangePasswordFormValues = z.infer<typeof changePasswordSchema>;
